<script lang="ts">
	import { currentLanguage } from '$lib/stores/i18n';
	import AIPage from '../../ai/+page.svelte';
	import { getLanguageFromPath } from '$lib/stores/i18n';
	import { page } from '$app/stores';

	export let data: { lang?: string };

	// Set language from route parameter
	$: if (data?.lang) {
		currentLanguage.set(data.lang as 'en' | 'th');
	}
	$: lang = data?.lang || getLanguageFromPath($page.url.pathname) || 'en';
</script>

<svelte:head>
	<!-- BreadcrumbList for /en/ai, /th/ai: static JSON so prerender outputs valid JSON (no Svelte interpolation inside ld+json) -->
	{#if lang === 'en'}
		<script type="application/ld+json">
			{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://3dai.co.th/en"},{"@type":"ListItem","position":2,"name":"AI Generated 3D","item":"https://3dai.co.th/en/ai"}]}
		</script>
	{:else}
		<script type="application/ld+json">
			{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"หน้าแรก","item":"https://3dai.co.th/th"},{"@type":"ListItem","position":2,"name":"สร้างโมเดล 3D ด้วย AI","item":"https://3dai.co.th/th/ai"}]}
		</script>
	{/if}
</svelte:head>

<AIPage />
